import React, { Component } from "react"
import Layout from "../components/Layout/layout"

class WorkPage extends Component {
  state = {
    smallScreen: false,
    modal: { name: "" },
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this))
    this.resize()
  }

  resize() {
    this.setState({ smallScreen: window.innerWidth <= 840 })
  }

  openModal(e) {
    this.setState({ modal: e })
    document.getElementById("modal").style.display = "block"
  }

  closeModal() {
    document.getElementById("modal").style.display = "none"
  }

  render() {
    let workData = this.props.data.allWorkJson.nodes[0]
    let workItems = []
    let i = 0
    workData.work_items.forEach(item => {
      workItems.push(
        <div
          key={i}
          onClick={this.openModal.bind(this, item)}
          className={
            this.state.smallScreen ? "grid-item-small" : "work-grid-item"
          }
          style={{
            backgroundImage: `url(${item.image})`,
            backgroundSize: "100%",
          }}
        ></div>
      )
      i++
    })
    return (
      <Layout page={"boarding"}>
        <h1 className="title">Boarding with Bark &amp; Breakfast</h1>
        <div className="text">Preparing for their stay...</div>
        <h2 className="subtitle">How it Works</h2>
        <div className="text">To get started with a reservation; call, text, or email Gus to book your dog's stay.  We will go over details and answer all your questions on the phone.</div>
        <div className="text">On the date of your reservation, we come to pick up your dogs for their stay, and bring them home when you're ready.</div>
        <div className="text">Pickup and dropoff is offered from 8am to 8pm. Arrival must be in daylight hours to safely introduce your dog to our current group.</div>
        <div className="text">Reservations may be made no further than 6 months in adavance.</div>
        <h2 className="subtitle">What to Pack</h2>
        <div className="text"><strong>Be sure to bring...</strong> food, medication/supplements, bedding and toys (washable only), and a healthy supply of treats.  If you forget something, don't worry, we have extras of <strong>everything!</strong></div>
        <div className="subtitle">Boarding Rates</div>
        <div className="text">We offer competitive rates and a multi-dog discount.</div>
        <div className="text">
          First Dog - $60/day<br />
          Each Additional Dog - $40/day<br />
        </div>
        <div className="text">Pickup and dropoff offered free of charge with 30 miles of our location.  Ourside our radius we charge $20 each way.</div>
        <div className="text">Payments may be made with cash or check within 30 days of invoice date.</div>
        <div className="text">We charge for every 24 hours or part thereof and invoice separately per household.</div>
        <div className="text">First time clients will need to arrange a one-night trial stay if their first booking is longer than two nights.</div>
        <div className="text">Dogs must be up to date on the following vaccinations.</div>
        <div className="text">
        <ul style={{"text-align": "left"}}>
          <li>Rabies</li>
          <li>DHPP (Distemper, Hepatitus, Parainfluenza, Parvovirus)</li>
          <li>Leptospirosis (sometimes included with distemper combo)</li>
          <li>Canine Influenza or CIV (strongly recommended)</li>
          <li>Negative fecal check (within 6 months of stay)</li>
          <li>Flea/tick preventative (year round)</li>
        </ul>  
        </div>
        <div
          className={
            this.state.smallScreen
              ? "grid-container-small"
              : "work-grid-container"
          }
        >
          { /* {workItems} commented out until we have testimonials */}
        </div>
        <div id="modal" className="modal" onClick={this.closeModal}>
          <div
            className={
              this.state.smallScreen ? "modal-content-small" : "modal-content"
            }
          >
            <span className="modal-close">&times;</span>
            <div className="modal-grid-container">
              <div className="modal-grid-item-left">
                <span className="modal-title">{this.state.modal.name}</span>
                <p className="modal-text">{this.state.modal.description}</p>
                <p className="modal-text">
                  Completed: {this.state.modal.completed}
                </p>
              </div>
              <div className="modal-grid-item-right">
                <img
                  src={this.state.modal.image}
                  alt={this.state.modal.name}
                  className="modal-image"
                ></img>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
export default WorkPage

export const query = graphql`
  query {
    allWorkJson {
      nodes {
        id
        title
        description
        text
        work_items {
          name
          description
          completed
          image
        }
      }
    }
  }
`
